module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-thankyou-3de1d5ce783b49b2c3d6b166499cb0d6.png";